import { allPayments, constDate, describeAmount, once, scaleAmount, unit, } from '../payments/constructors.js';
import { classificationLabel } from '../payments/dsl.js';
import { collectPayments } from '../payments/occurrences.js';
function monthOf(date) {
    return date.slice(0, 7);
}
function lineOf(classification) {
    return classification === undefined ? '' : classificationLabel(classification).toLowerCase();
}
function repeatingPartsOf(payment) {
    switch (payment.kind) {
        case 'repeat':
            return [payment];
        case 'all':
        case 'first':
            return payment.payments.flatMap(repeatingPartsOf);
        case 'notToExceed':
            return repeatingPartsOf(payment.payment);
        case 'once':
        case 'zero':
            return [];
        default: {
            const _exhaustive = payment;
            throw new Error(`Unhandled payment: ${JSON.stringify(_exhaustive)}`);
        }
    }
}
export function projectedPayments(schedules, from, until) {
    const context = { currentDate: from };
    const key = (ownership, classification, due) => `${ownership}\u0000${lineOf(classification)}\u0000${monthOf(due)}`;
    const committed = new Set(schedules
        .filter((schedule) => !schedule.estimate)
        .flatMap((schedule) => repeatingPartsOf(schedule.spec).flatMap((part) => collectPayments(part, context, until).map((due) => key(schedule.ownershipDisplayId, due.classification, due.dueDate)))));
    return schedules.map((schedule) => {
        if (!schedule.estimate)
            return schedule.spec;
        return allPayments(...collectPayments(schedule.spec, context, until)
            .filter((due) => !committed.has(key(schedule.ownershipDisplayId, due.classification, due.dueDate)))
            .map((due) => once(constDate(due.dueDate), describeAmount(due.description ?? '', scaleAmount(due.amount, unit())))));
    });
}
//# sourceMappingURL=projectedPayments.js.map